// API URL utility for supporting custom domains
// This prevents cross-origin cookie issues when accessed from custom domains

const getApiBaseUrl = () => {
  const currentOrigin = window.location.origin;
  const previewUrl = process.env.REACT_APP_BACKEND_URL || '';
  
  // If we're on the preview URL or localhost, use the configured backend URL
  if (currentOrigin.includes('preview.emergentagent.com') || 
      currentOrigin.includes('localhost') ||
      currentOrigin.includes('127.0.0.1')) {
    return previewUrl;
  }
  
  // For custom domains, use relative URL (empty string) so requests go through the same domain
  // The custom domain's proxy will route /api/* to the backend
  return '';
};

export const BACKEND_URL = getApiBaseUrl();
export const API = `${BACKEND_URL}/api`;
